import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const popup = css`
  position: relative;
  width: 410px;
  display: flex;
  pointer-events: all;
  flex-direction: column;
`;

export const header = css`
  display: flex;
  align-items: center;
  flex-flow: row;
  gap: 18px;
  min-height: 25px;
  justify-content: space-between;
`;

export const titleWrapper = css`
  display: flex;
  flex-direction: column;
  padding: 17px 20px;
  background: ${colors.gray.lightest};
  border-bottom: ${colors.gray.light} solid 1px;
`;

export const body = css`
  padding: 20px;

  display: flex;
  flex-flow: column;
  gap: 20px;
`;

export const headerDivider = css`
  height: 48px;
  background-color: ${colors.gray.light};
`;

export const headerTitle = css`
  flex: 3;
`;

export const arrivalTimes = css`
  display: flex;
  flex-flow: row;
`;

export const arrivalTimeDescription = css`
  flex: 2;
  align-self: center;
`;

export const arrivalTimeInfo = css`
  flex: 1;
  display: flex;
  flex-flow: column;
`;

export const lateArrivalWarning = css`
  color: ${colors.warning.default};
`;

export const actualArrivalTime = css`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 4px;
`;

export const arrivalInTimeIcon = css`
  color: ${colors.success.default};
`;
